import { useEffect } from 'react';
import OAutocomplete from '../../../../UI/MuiAutocomplete';
import useHttp from '../../../../../hooks/use-http';
import { urls } from '../api/urls';
import OInput from '../../../../UI/FormControls/OInput';
import TextArea from '../../../../UI/FormControls/TextArea';
import DragAndDrop from '../../../../UI/DragAndDrop';

const Inputs = ({
  formValue,
  setFormValue,
  file,
  setFile,
  handleUkloniFile,
}) => {
  const { sendRequest: getDelovi, data: deloviData } = useHttp('');
  const shouldShowField = localStorage.sa === 'true';
  useEffect(() => {
    getDelovi({ url: urls.GET_DELOVI_COMBO });
  }, []);

  const handleClickDelovi = (item) => {
    setFormValue((curr) => {
      return {
        ...curr,
        idDela: item.id,
        nazivDela: item.vrednost,
        cena: item.prodajnaCena,
        nabavnaCena: item.nabavnaCena,
      };
    });
  };

  const handleChange = (item) => {
    setFormValue((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };
  const handleFiles = (files) => {
    setFormValue((curr) => {
      return { ...curr, nazivFajla: files[0].name };
    });
    setFile(files);
  };
  return (
    <div>
      {' '}
      <OAutocomplete
        data={deloviData}
        value={formValue.nazivDela}
        handleClick={handleClickDelovi}
        label="Deo"
        style={{ width: '100%' }}
      />
      <OInput
        label="Količina"
        name="kolicina"
        value={formValue.kolicina}
        handleChange={handleChange}
        style={{ width: '100%' }}
        type="number"
      />
      <OInput
        label="Cena"
        name="cena"
        value={formValue.cena}
        handleChange={handleChange}
        style={{ width: '100%', display: !shouldShowField ? 'none' : 'block' }}
        type="number"
      />
      <OInput
        label="Nabavna cena"
        name="nabavnaCena"
        value={formValue.nabavnaCena}
        handleChange={handleChange}
        style={{ width: '100%', display: !shouldShowField ? 'none' : 'block' }}
        type="number"
      />
      <TextArea
        label="Napomena"
        rows="4"
        name="napomena"
        value={formValue.napomena}
        handleChange={handleChange}
        style={{ width: '100%', height: '100px' }}
      />
      <DragAndDrop
        handleFiles={handleFiles}
        maxFiles={5}
        addedFiles={file}
        handleRemoveFile={handleUkloniFile}
      />
    </div>
  );
};

export default Inputs;
